export default {
  payments: 'reportTemplatePayments',
  operations: 'reportTemplateOperations',
  interchange: 'reportTemplateInterchange',
  chargebacks: 'reportTemplateChargebacks',
  fraud: 'reportTemplateFraud',
  remittanceOperations: 'reportTemplateRemittanceOperations',
  remittancePayments: 'reportTemplateRemittancePayments',
  billingOperations: 'reportTemplateBillingOperations',
};
